import { useMemo } from "react";

import {
    useUpgradableSites,
    useUpgradableStandardSites
} from "@/components/user-context/helpers/cohorts";
import { experiments } from "@/utils/experiment/manifest";
import { useExperiment } from "@/utils/experiment/use-experiment";

/**
 * Checks if the user is enrolled in the upgrade S2P experiment and returns the existing sites
 * if they are, it returns the upgradeable standard sites and upgradable sites
 * if they are not, it returns undefined
 * @returns {ExistingSite[] | undefined} The existing sites or undefined
 */
export function useGetExistingSites() {
    const upgradeableStandardSites = useUpgradableStandardSites();
    const upgradableSites = useUpgradableSites();
    const suggestedSiteCloudId =
        upgradeableStandardSites?.[0]?.cloudId ??
        upgradableSites?.[0]?.cloudId ??
        "";
    const upgradeS2pExperiment = useExperiment(
        experiments.twcg907Astro540WacUpgradeS2p,
        {
            suggestedSiteCloudId
        }
    );

    return useMemo(() => {
        const isEnrolledInExperiment =
            upgradeS2pExperiment && upgradeS2pExperiment.type === "enrolled";

        return isEnrolledInExperiment &&
            upgradeS2pExperiment.value === "variation"
            ? [...(upgradeableStandardSites ?? []), ...(upgradableSites ?? [])]
            : undefined;
    }, [upgradeS2pExperiment, upgradeableStandardSites, upgradableSites]);
}
